import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

export default class BeaconLinkController extends BridgeComponent {
  static component = "intercom";
  static values = { article: String }

  open(e) {
    e.preventDefault();

    logEvent("Get Help - Opened Intercom", { location: "Message" });
    
    this.send("present", () => {
    });
  }
}
